<template>
  <div class="listing-page">
    <header class="header">
      <div class="row align-center">
        <div class="columns small-12 medium-8 text-center">
          <br />
          <h1>{{ title }}</h1>
          <p>
            {{ description }}
          </p>
        </div>
      </div>
    </header>
    <section class="row">
      <div class="columns small-12">
        <ul class="row block-grid small-up-2 medium-up-3 large-up-4 align-center">
          <li v-for="item in curriculum.items" :key="item.link">
            <figure class="card-img">
              <nuxt-link
                :to="localePath(item.link)"
                title="Browse resources in this curriculum learning area"
              >
                <nuxt-img
                  :src="'/images/curriculums/' + curriculum.slug + '-' + item.slug + '.png'"
                  :alt="item.name"
                  width="900"
                  height="479"
                  format="webp"
                />
              </nuxt-link>
            </figure>

            <template v-if="curriculum.name !== $config.curriculumV9">
              <h2>
                <nuxt-link :to="localePath(item.link)" title="Browse resource in this curriculum">
                  {{ item.name }}
                </nuxt-link>
              </h2>

              <ul v-if="item.items" class="link-list">
                <li v-for="subitem in item.items" :key="subitem.link">
                  <nuxt-link :to="localePath(subitem.link)" title="View resources">
                    {{ subitem.name }}
                  </nuxt-link>
                </li>
              </ul>

              <ul v-else class="link-list">
                <li>
                  <nuxt-link
                    :to="localePath(item.link)"
                    title="Browse resources in this curriculum learning area"
                  >
                    View all &rarr;
                  </nuxt-link>
                </li>
              </ul>
            </template>
          </li>
        </ul>
      </div>
    </section>
  </div>
</template>

<script>
/* List of curriculum learning areas
 *
 * @parent: /curriculum/
 * @requests:
 * @events: loadCurriculum
 * @props:
 * @components:
 * @methods:
 */

import { mapGetters } from 'vuex';
import curriculumsList from '~/data/curriculums.json';

export default {
  name: 'Curriculum',
  asyncData({ app, params, error }) {
    const data = {};
    const curriculums = curriculumsList[app.i18n.locale];
    const curriculum = curriculums.find(c => c.slug === params.slug);

    if (curriculum) {
      data.curriculum = curriculum;
      data.title = curriculum.name;
    } else {
      // No page matching this route
      error({ statusCode: 404, message: 'Curriculum page not found' });
    }

    data.curriculums = curriculums;

    return data;
  },
  data() {
    return {
      title: 'School Curriculums',
      description:
        'Browse teaching resources aligned to the standards. Search by learning area, strand, sub-strand and code.',
      curriculums: curriculumsList[this.$i18n.locale],
    };
  },
  head() {
    return {
      title: this.title,
      meta: [
        { hid: 'title', name: 'title', content: this.title + ' - Curriculum Aligned' },
        { hid: 'description', name: 'description', content: this.description },
      ],
      link: this.$canonicalLink(this.$route),
    };
  },
  computed: {
    ...mapGetters(['location']), // 'curriculum'
  },
  mounted() {
    this.$mzAnalyticsApi({
      event: 'pageView',
    });
  },
};
</script>
<style scoped lang="scss">
@import '~/assets/scss/components/_card.scss';

.bg-curriculum {
  background-color: $vivid-amber-500;
}

.listing-page .header figure img {
  width: 100%;
}

a {
  &:hover,
  &:focus {
    text-decoration: none;
  }
}

h2 {
  margin-top: 1.25rem;
  a {
    color: inherit;
  }
}

.card-img {
  margin-top: 0.5rem;
  margin-bottom: 1.5rem;
}
</style>
